import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApplicationState } from 'src/app/state/reducers';
import { selectIsUserSE } from 'src/app/state/selectors/customer-account.selector';

@Component({
  selector: '[my-bill-odb-total]',
  templateUrl: './odb-total.component.html',
  standalone: false,
})
export class OdbTotalComponent {
  @Input() amount: string;
  @Input() showVatText = false;
  readonly selectIsUserSE$ = this.store.select(selectIsUserSE);

  constructor(private store: Store<ApplicationState>) {}
}
